export const theme = {
    common: {
        delete: 'Delete'
    },
    modal: {
        cancelText: 'Cancel',
        saveText: 'Save',
        okText: 'OK',
        duplicationsCheckText: 'Duplications Check',
        duplicationsTitle: 'Duplications Check List',
        themeName: 'Theme Name',
        baseThemeBelonging: 'Base Themes Belonging',
        column: {
            themeId: 'Theme ID',
            category1: 'Category 1',
            category2: 'Category 2',
            themeName: 'Theme Name'
        },
        baseTheme: {
            addTitle: 'Add Base Theme',
            editTitle: 'Edit Base Theme',
            name: 'Base Theme Name'
        },
        clientTheme: {
            addTitle: 'Add Client Theme',
            editTitle: 'Edit Client Theme',
            name: 'Client Theme Name'
        }
    },
    baseTheme: {
        title: 'Base Theme',
        column: {
            baseThemeName: 'Base Theme Name',
            createdDate: 'Created Date',
            createdBy: 'Created By'
        }
    },
    clientTheme: {
        title: 'Client Theme',
        column: {
            clientThemeName: 'Client Theme Name',
            createdDate: 'Created Date',
            createdBy: 'Created By'
        }
    },
    error: {
        duplicatedNameMsg: 'Duplicated Name existed'
    },
    warningMsg: {
        deleteConfirm: 'Delete the 「{{name}}」. Is there any problem?',
        optSuccess: 'Processing ended normally.',
        optError: 'Processing failed.',
        baseThemeDeleteError:
            'Base Theme:「{{baseThemeName}}」is being used by Client Theme(s): {{clientThemes}}. Please confim.',
        clientThemeDeleteError:
            'Client Theme:「{{clientThemeName}}」is being used by Company: {{clients}}. Please confim.'
    }
}
